import React from 'react'
import { Extract, actions } from './.'
import { actions as balanceActions } from '../../features/Balance'
import { connect } from 'react-redux'

const mapStateToProps = ({ extract, balance, catalog }) => ({
  ...extract,
  balance,
  currency: {
    label: catalog.currencyConfiguration.pointsName,
    decimalPlaces: catalog.currencyConfiguration.decimalPlaces,
    isLoading: catalog.isLoading
  }
})

const mapDispatchToProps = dispatch => ({
  fetchExtractTotalizer: () => dispatch(actions.fetchExtractTotalizer()),
  loadBalance: cached => dispatch(balanceActions.loadBalance(cached)),
  fetchExtract: params => dispatch(actions.fetchExtract(params)),
  fetchCreditToExpire: periodId =>
    dispatch(actions.fetchCreditToExpire(periodId)),
  fetchCampaignName: () => dispatch(actions.fetchCampaignName())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(props => <Extract {...props} />)



// WEBPACK FOOTER //
// ./src/Participant/Extract/ExtractPage.js